import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { Skeleton } from 'antd'
import PageLayout from '@BUP/components/Layout/Page'
import { getFetcher } from '@BUP/services/Axios'
import AlertComponent from '@BUP/components/Generics/Alert'
import { ComplaintEntryDescriptions } from '@BUP/components/complaint/entry/descriptions'

export function LogbookShowComplaintEntryPage () {
  const { complaintId, complaintEntryId } = useParams()
  const { data, isLoading, error, mutate } = useSWR(`/complaints/${complaintId}/complaint-entries/${complaintEntryId}?include=complaintEntryAttachments`, getFetcher, {
    errorRetryCount: 3,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })
  const content = error
    ? <AlertComponent type='error' message='Error' />
    : <ComplaintEntryDescriptions complaintEntry={data} mutate={mutate} />
  return (
    <PageLayout backButton pageName='Entrada'>
      <Skeleton loading={isLoading}>
        {content}
      </Skeleton>
    </PageLayout>
  )
}
